import {action, observable} from "mobx";

import courierService from "../services/courierService";
import appStore from "./appStore";
import config from "../_core/config";
import {b64DecodeToUrl} from "../utils/helpers";

import i18n from "../i18n";
class courierStore {
    @observable courierDedicationList = [];

    @action getCourierList = async params => {
        const resultOfRequest = await courierService.getCourierList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getCourier = async params => {
        const resultOfRequest = await courierService.getCourier(params);

        if (resultOfRequest.data.photo) {
            resultOfRequest.data.photoId = resultOfRequest.data.photo;
            resultOfRequest.data.photo = `${config.getBasePublicUrl()}api/panel/v1/image/${
                resultOfRequest.data.photo
            }`;
        }
        return resultOfRequest;
    };

    @action getCourierByTckn = async params => {
        const resultOfRequest = await courierService.getCourierByTckn(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getDedicationList = async params => {
        const resultOfRequest = await courierService.getDedicationList(params);
        return resultOfRequest;
    };

    @action updateCourier = async params => {
        const resultOfRequest = await courierService.updateCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateCourier.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action createCourier = async params => {
        const resultOfRequest = await courierService.createCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.createCourier.successMessageContent", {ns: "common"})
        });
        return resultOfRequest.data;
    };

    @action uploadImage = async params => {
        const resultOfRequest = await courierService.uploadImage(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action updateStatus = async params => {
        const resultOfRequest = await courierService.updateStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action updateCourierDocumentStatus = async params => {
        const resultOfRequest = await courierService.updateCourierDocumentStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };

    @action createCourierCallRecords = async params => {
        const resultOfRequest = await courierService.createCourierCallRecords(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Arama kaydı başarıyla oluşturuldu."
        });
        return true;
    };

    @action getCourierCallStatuses = async params => {
        const resultOfRequest = await courierService.getCourierCallStatuses();
        if (resultOfRequest.status !== 200) {
            return [];
        }
        return resultOfRequest.data;
    };
    /* 
    will be removed on backend
    @action createCourierEquipmentRequests = async params => {
        const resultOfRequest = await courierService.createCourierEquipmentRequests(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Ekipman talebi başarıyla oluşturuldu."
        });
        return true;
    }; */

    @action updateCourierOnboardingStatus = async params => {
        const resultOfRequest = await courierService.updateCourierOnboardingStatus(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action rejectOnboardingDocumentVerificationStatus = async params => {
        const resultOfRequest = await courierService.rejectOnboardingDocumentVerificationStatus(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action approveOnboardingDocumentVerificationStatus = async params => {
        const resultOfRequest = await courierService.approveOnboardingDocumentVerificationStatus(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.updateStatus.successMessageContent", {ns: "common"})
        });
        return true;
    };
    @action blockCourier = async params => {
        const resultOfRequest = await courierService.blockCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye kara listeye alındı."
        });
        return true;
    };
    @action unblockCourier = async params => {
        const resultOfRequest = await courierService.unblockCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye kara listeden çıkarıldı."
        });
        return true;
    };
    @action rejectCourierApplication = async params => {
        const resultOfRequest = await courierService.rejectCourierApplication(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye kalıcı olarak reddedildi."
        });
        return true;
    };
    @action undoCourierRejection = async params => {
        const resultOfRequest = await courierService.undoCourierRejection(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: "Kurye reddi geri alındı."
        });
        return true;
    };
    @action getDocumentsProgress = async params => {
        const resultOfRequest = await courierService.getDocumentsProgress(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getCourierDocumentsRejectHistory = async params => {
        const resultOfRequest = await courierService.getCourierDocumentsRejectHistory(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action changePassword = async params => {
        const resultOfRequest = await courierService.changePassword(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.courier.changePassword.successMessageContent", {
                ns: "common"
            })
        });
        return true;
    };

    @action getCourierMapList = async params => {
        const resultOfRequest = await courierService.getCourierMapList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getCourierStatusLogs = async params => {
        const resultOfRequest = await courierService.getCourierStatusLogs(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getDedicationsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getDedicationsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getFeedbacksReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getFeedbacksReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getSubCompaniesReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getSubCompaniesReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getShiftsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getShiftsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getDailyShiftsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getDailyShiftsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getHoursReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getHoursReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }

        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action uploadCourierFile = async params => {
        const resultOfRequest = await courierService.uploadCourierFile(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action insertCourierFiles = async params => {
        const resultOfRequest = await courierService.insertCourierFiles(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action removeCourierFile = async params => {
        const resultOfRequest = await courierService.removeCourierFile(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data;
    };

    @action getPoolCouriers = async params => {
        const resultOfRequest = await courierService.getPoolCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCouriersOfCompany = async params => {
        const resultOfRequest = await courierService.getCouriersOfCompany(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action dedicateCompanyCouriers = async params => {
        const resultOfRequest = await courierService.dedicateCompanyCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action courierDedicationLog = async params => {
        const resultOfRequest = await courierService.courierDedicationLog(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getRegions = async params => {
        const resultOfRequest = await courierService.getRegions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data;
        }
    };

    @action getRegionGroups = async params => {
        const resultOfRequest = await courierService.getRegionGroups(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectCities = async params => {
        const resultOfRequest = await courierService.getMultipleSelectCities(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectCompanies = async params => {
        const resultOfRequest = await courierService.getMultipleSelectCompanies(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectRegions = async params => {
        const resultOfRequest = await courierService.getMultipleSelectRegions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectRegionGroups = async params => {
        const resultOfRequest = await courierService.getMultipleSelectRegionGroups(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getMultipleSelectSubCompanies = async params => {
        const resultOfRequest = await courierService.getMultipleSelectSubCompanies(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getSubCompaniesByRegionGroup = async params => {
        const resultOfRequest = await courierService.getSubCompaniesByRegionGroup(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action courierUpdateDedication = async params => {
        const resultOfRequest = await courierService.courierUpdateDedication(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            appStore.showSuccessMessage({
                content: i18n.t("stores.courier.courierUpdateDedication.successMessageContent", {
                    ns: "common"
                })
            });
            return resultOfRequest.data;
        }
    };

    @action updateAllCouriersDisable = async params => {
        const resultOfRequest = await courierService.updateAllCouriersDisable(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            appStore.showSuccessMessage({
                content: i18n.t("stores.courier.updateAllCouriersDisable.successMessageContent", {
                    ns: "common"
                })
            });
            return resultOfRequest.data;
        }
    };

    @action getDeliveryLocations = async params => {
        const resultOfRequest = await courierService.getDeliveryLocations(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCurrentDelivery = async params => {
        const resultOfRequest = await courierService.getCurrentDelivery(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return resultOfRequest;
        }
        return resultOfRequest.data;
    };

    @action getSlotCouriers = async params => {
        const resultOfRequest = await courierService.getSlotCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data;
        }
    };

    @action getAvailableCouriersForPreferredCourier = async (params, allCityCouriers = true) => {
        const resultOfRequest = await courierService.getAvailableCouriersForPreferredCourier(
            params,
            allCityCouriers
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data.result;
        }
    };

    @action listAvailableCouriers = async params => {
        const resultOfRequest = await courierService.listAvailableCouriers(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data.result;
        }
    };

    @action getCourierHomeLocation = async params => {
        const resultOfRequest = await courierService.getCourierHomeLocation(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };
    @action getCourierShifts = async params => {
        const resultOfRequest = await courierService.getCourierShifts(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };
    @action getDedicatedCourier = async params => {
        const resultOfRequest = await courierService.getDedicatedCourier(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action updateShiftSuggestionOptions = async params => {
        const resultOfRequest = await courierService.updateShiftSuggestionOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            appStore.showSuccessMessage({
                content: "Vardiya öneri ayarları değiştirildi."
            });
            return resultOfRequest.data;
        }
    };
    @action updateCourierTransferCenter = async params => {
        const resultOfRequest = await courierService.updateCourierTransferCenter(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        } else {
            return resultOfRequest.data;
        }
    };

    @action getCourierTerminals = async params => {
        const resultOfRequest = await courierService.getCourierTerminals(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action getShiftEditLogsReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await courierService.getShiftEditLogsReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action updateCourierTerminal = async params => {
        const resultOfRequest = await courierService.updateCourierTerminal(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action getCourierInfo = async params => {
        const resultOfRequest = await courierService.getCourierInfo(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data.result;
    };

    @action getCustomerMapList = async params => {
        const resultOfRequest = await courierService.getCustomerMapList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };

    @action listMotorTypes = async params => {
        const resultOfRequest = await courierService.listMotorTypes(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        } else {
            return resultOfRequest.data.result;
        }
    };

    @action listDrivingLicenseTypes = async params => {
        const resultOfRequest = await courierService.listDrivingLicenseTypes(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
        return resultOfRequest.data;
    };
}

export default new courierStore();
